import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { Modal } from "reactstrap";
import ContestModel from "./ContestModel";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getContestPraposedData,
  getContestReplyChildComment,
  postContestComment,
} from "../../../../../redux/contest/action";
import { useDispatch, useSelector } from "react-redux";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import { useParams } from "react-router-dom";
import ReactSelect from "react-select";
import CustomRatingLabel from "../../../../Common/CustomeLabel/CustomRatingLabel";
import PublicComment from "./Comments/PublicComment";
import EntryPagination from "../../SearchAll/AllPosts/CustomPagination/EntryPagination";
import pdficon from "../../../../Common/FilesRelevent/pdf.png";
import RateTOUSER from "../../../../Common/CustomeLabel/RateTOUSER";
import CustomeLike from "../../../../Common/CustomeLabel/CustomeLike";
import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import { IS_LOGGED_IN_USER } from "../../../../../assests/extention/commonfunction";
import Access from "../../../../CustomComponents/Access/Access";
import DisplayFileExtensionWise from "../../../../Common/FilesRelevent/DisplayFileExtensionWise";

const handleImageError = (e) => {
  e.target.src = pdficon;
};
export default function CommonContestEntries({ posts }) {
  const [like, setLike] = useState(0);
  const [review, setReview] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [modal, setModal] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [values, setValues] = useState(false);
  const [commentid, setCommentID] = useState(false);
  const [viewcommentid, setViewCommentID] = useState(null);
  const [publicComments, setPublicComments] = useState("");
  const [publicChildCpmment, setpublicChildCpmment] = useState("");
  const [selectedOption, setselectedOption] = useState([
    { value: "1", label: "Recent" },
  ]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [size, setSize] = useState(12);

  const toggle = () => setModal(!modal);

  const dispatch = useDispatch();

  const openmodelandpassvalue = (item) => {
    if (IS_LOGGED_IN_USER) {
      setValues(item);
      toggle();
    }
    else {
      setModal1(true)
    }
  };
  const formik = useFormik({
    initialValues: {
      comment: "",
    },
    validationSchema: Yup.object({
      comment: Yup.string()
        .max(500, "Must be 500 characters or less")
        .required("Required"),
    }),
    onSubmit: (values, { resetForm }) => {
      // resetForm();
      if (IS_LOGGED_IN_USER) {
        submitform(values, resetForm);
      }
      else {
        setModal1(true)
      }
    },
  });

  const submitform = (values1, resetForm) => {
    const data = {
      message: values1.comment,
      post_id: posts.id,
      type: 1,
      size: size,
    };
    dispatch(postContestComment(data, setLoading));
    resetForm();
  };

  const profile = useSelector(({ profile: { profiledata } }) => profiledata);

  useEffect(() => {
    if (posts?.id) {
      // fetchComments();
    }
    if (viewcommentid !== null) {
      fetchChildComments(viewcommentid);
    }
  }, [dispatch, posts?.id]);

  const fetchChildComments = async (viewcommentid) => {
    const response = await dispatch(getContestReplyChildComment(posts?.id));
    if (response) {
      setpublicChildCpmment(response);
    }
  };

  const toggleCommentID = (id) => {
    if (IS_LOGGED_IN_USER) {
      setCommentID((prevCommentID) => (prevCommentID === id ? null : id));
    }
    else {
      setModal1(true)
    }
  };

  const togglesetViewCommentID = (id) => {
    setViewCommentID((prevCommentID) => (prevCommentID === id ? null : id));
  };

  const options = [
    { value: "1", label: "Recent" },
    { value: "2", label: "Old" },
    { value: "3", label: "Most Rated" },
    { value: "4", label: "Least Rated" },
    { value: "5", label: "Most Liked" },
    { value: "6", label: "Least Liked" },
    { value: "7", label: "Most Viewed" },
    { value: "8", label: "Least Viewed" },
  ];
  const getproposalcontestlist = useSelector(
    ({ contest: { getproposalcontestlist } }) => getproposalcontestlist
  );

  useEffect(() => {
    if (posts.id != undefined) {
      dispatch(
        getContestPraposedData(
          posts?.id,
          selectedOption?.value ? selectedOption?.value : "",
          pageNumber,
          size
        )
      );
    }
  }, [posts, selectedOption, pageNumber]);

  return (
    <div className="project-details  entries-lastimg">
      {modal1 ? (<Access modal={modal1} setModal={setModal1} state={"state"} />) : ("")}

      <div className="tab-sec">
        <div className="entries">
          <div className="entries-first">
            <h4>
              Showing &nbsp;
              {Array.isArray(getproposalcontestlist) &&
                getproposalcontestlist?.length}
              /{posts?.proposal_count} entries
            </h4>
            <div className="sort-select">
              <div className="select-flex">
                <p>Sort by :</p>
                <ReactSelect
                  value={selectedOption}
                  onChange={(option) => setselectedOption(option)}
                  options={options}
                />
              </div>
            </div>
          </div>
          {Array.isArray(getproposalcontestlist) && (
            <div className="post-details">
              {getproposalcontestlist.length > 0 ? (
                <div className="row entries-row">
                  {getproposalcontestlist.map((item, index) => (
                    <div key={index} className="col-md-4">
                      <div className="entries-img">
                        <div onClick={() => openmodelandpassvalue(item)}>
                          <div className="entries-sec">
                            <h6>#{item?.entry_number}</h6>
                            <p>
                              By
                              <span>
                                {item.first_name} {item.last_name}.
                              </span>
                            </p>
                          </div>
                          <DisplayFileExtensionWise className="w-100 ent-img" item={{ file: Array.isArray(item.files) && item.files[0]?.file }} />
                        </div>
                        <div onClick={!IS_LOGGED_IN_USER ? () => setModal1(true) : undefined}
                          // style={{ pointerEvents: !IS_LOGGED_IN_USER ? "auto" : "none", }}
                        >
                          <div
                            // style={{ pointerEvents: IS_LOGGED_IN_USER ? "auto" : "none", }}
                            className="star-sec" >
                            <RateTOUSER
                              posts={posts}
                              values={item}
                              rating={review}
                            />
                            <CustomeLike
                              posts={posts}
                              like={like}
                              setLike={setLike}
                              values={item}
                            />
                          </div>
                        </div>

                      </div>
                    </div>
                  ))}
                  <EntryPagination
                    totalitemcounts={posts?.proposal_count}
                    size={size}
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                  />
                </div>
              ) : (
                <PostNotFound title={"No Entries Yet"} />
              )}
            </div>
          )}

          <div className="public-comment ">
            <h6>Public Comment section</h6>
            <div className="comment-sec1">
              <form onSubmit={formik.handleSubmit}>
                <div className="comment-sec">
                  <img
                    src={
                      profile?.profile_image
                        ? profile?.profile_image
                        : ProfilePic
                    }
                    alt=""
                  />
                  <div className="w-100">
                    <textarea
                      type="text"
                      placeholder="Write a comment"
                      className="form-control"
                      id="comment"
                      name="comment"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.comment}
                    />
                  </div>
                </div>
                {formik.touched.comment && formik.errors.comment ? (
                  <div style={{ color: "red" }} className="error">
                    {formik.errors.comment}
                  </div>
                ) : null}
                <div className="send-btn">
                  <button type="submit" className="btn">
                    Send
                  </button>
                </div>
              </form>
            </div>
            <PublicComment
              size={size}
              setSize={setSize}
              posts={posts}
              publicComments={publicComments}
              toggleCommentID={toggleCommentID}
              setCommentID={setCommentID}
              setViewCommentID={setViewCommentID}
              togglesetViewCommentID={togglesetViewCommentID}
              commentid={commentid}
              viewcommentid={viewcommentid}
            />
          </div>
          <Modal
            isOpen={modal}
            toggle={toggle}
            size="xl"
            className="entries-modal"
          >
            <ContestModel
              modal={modal}
              setModal={setModal}
              values={values}
              posts={posts}
            />
          </Modal>
        </div>
      </div>
    </div>
  );
}
